var isEasingGenerator = function isEasingGenerator(easing) {
  return typeof easing === "object" && Boolean(easing.createAnimation);
};

export { isEasingGenerator };